import { CustomerLogoutResponse } from '@porterin/booking-flow/src/auth/domain/api-models/CustomerLogoutApiModel';
import { API_ENDPOINTS } from '@porterin/booking-flow/src/auth/domain/config/api';
import { CustomerLogout } from '@porterin/booking-flow/src/auth/domain/entities/CustomerLogout';
import { toCustomerLogoutEntity } from '@porterin/booking-flow/src/auth/domain/entity-mappers/CustomerLogoutEntityMapper';
import {
  createAuthenticatedHeaders,
  createNetworkError,
} from '@porterin/booking-flow/src/auth/domain/helpers/authHelpers';
import { handleApiError } from '@porterin/component-library/src/ts-utils/analytics/sentry/SentryHelpers';
import axios, { AxiosError } from 'axios';

export const customerLogout = async (
  webTrackingId: string,
  authToken: string,
  mobile: string,
): Promise<CustomerLogout> => {
  try {
    const headers = createAuthenticatedHeaders(
      webTrackingId,
      authToken,
      mobile,
    );
    const payload = '';

    const response = await axios.post<CustomerLogoutResponse>(
      `${API_ENDPOINTS.CUSTOMER_LOGOUT}`,
      payload,
      { headers },
    );

    return toCustomerLogoutEntity(response.data);
  } catch (error) {
    handleApiError(error, 'customerLogout');
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError;
      throw createNetworkError(
        axiosError.response?.status ?? 500,
        axiosError.message,
      );
    }
    throw error;
  }
};
